import { Inject, Injectable } from "@angular/core";
import { tap } from "rxjs";
import { TenantService } from "./tenant.service";
import { WINDOW } from "../shared/window.token";
import { TenantConfiguration } from "../shared/interfaces/tenantConfiguration.interface";
import { Title } from "@angular/platform-browser";
import { DOCUMENT } from "@angular/common";

@Injectable({
    providedIn: 'root'
})
export class InitService {
    tenantConfigurations!: TenantConfiguration;

    constructor(
        @Inject(WINDOW) private window: Window,
        @Inject(DOCUMENT) private document: Document,
        private tenantService: TenantService,
        private titleService: Title
    ) { }

    init() {
        let domain = this.window.location.host;
        return this.tenantService.getTenantConfigurationsByDomain(domain).pipe(
            tap((config) => {
                this.tenantConfigurations = config;
                this.titleService.setTitle(config.name);
                const favicon = this.document.querySelector<HTMLLinkElement>('link[rel="icon"]');
                if (favicon) {
                    favicon.href = config.iconUrl;
                }
            })
        );
    }
}